import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReportingDialog from './ReportingDialog';
import { history } from '../../index';

class Main extends Component {

  render() {

    return (
      <ReportingDialog
       extent={this.props.location.state.extent}
       definitionExpression={this.props.location.state.definitionExpression}
       screenshot={this.props.location.state.screenshot}
       onClose={() =>
         {
          history.goBack();
        }} />
    )
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  map: state.map
})

export default connect(mapStateToProps)(Main)
